export const isInviteForThisAccount = (email?: string) =>
  JSON.parse(localStorage?.getItem('inviteId') as string)?.email === email;
